var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-question"},[_c('b-form-textarea',{attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows,"max-rows":_vm.maxRows},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }